import { render, staticRenderFns } from "./AprovacaoCompra.vue?vue&type=template&id=0035bed1&"
import script from "./AprovacaoCompra.vue?vue&type=script&lang=js&"
export * from "./AprovacaoCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports